// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sl4agl0 {
  border-radius: var(--_18w76bw4q);
  padding: 14px;
}
@media screen and (min-width: 768px) {
  .sl4agl0 {
    border: 0;
    width: 212px;
    height: 102px;
    box-shadow: 0 0 10px 0 rgba(0,0,0,.15);
  }
}
@media screen and (min-width: 1024px) {
  .sl4agl0 {
    width: 252px;
    height: 142px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,aAAa;AACf;AACA;EACE;IACE,SAAS;IACT,YAAY;IACZ,aAAa;IACb,sCAAsC;EACxC;AACF;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".sl4agl0 {\n  border-radius: var(--_18w76bw4q);\n  padding: 14px;\n}\n@media screen and (min-width: 768px) {\n  .sl4agl0 {\n    border: 0;\n    width: 212px;\n    height: 102px;\n    box-shadow: 0 0 10px 0 rgba(0,0,0,.15);\n  }\n}\n@media screen and (min-width: 1024px) {\n  .sl4agl0 {\n    width: 252px;\n    height: 142px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
